import Link from "gatsby-link";
import * as React from "react";

interface IButtonProps {
  readonly extraClasses?: string;
  readonly href?: string;
  readonly to?: string;
  readonly target?: string;
  readonly content: string;
  readonly id?: string;
  readonly onClick?: any;
  readonly disabled?: boolean;
}
class Button extends React.Component<IButtonProps, {}> {
  private static defaultProps = {
    disabled: false
  };

  public render() {
    if (this.props.to) {
      return (
        <Link
          className={`btn ${
            this.props.extraClasses ? this.props.extraClasses : ""
          }`}
          to={this.props.to}
        >
          {this.props.content}
        </Link>
      );
    } else if (this.props.href) {
      if (!this.props.disabled) {
        return (
          <a
            className={`btn ${
              this.props.extraClasses ? this.props.extraClasses : ""
            }`}
            href={this.props.href}
            target={this.props.target}
            id={this.props.id}
            onClick={this.props.onClick}
          >
            {this.props.content}
          </a>
        );
      } else {
        return (
          <a
            className={"btn btn--disabled"}
            href={this.props.href}
            target={this.props.target}
            id={this.props.id}
          >
            {this.props.content}
          </a>
        );
      }
    }
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/button/button.tsx